import * as React from "react"
import { Link } from "gatsby"

import FeatureDivider from "./featureDivider"
import getPrice from "../lib/getPrice"

const FeaturedCollectionFetch = ({ collection, header, children, showPrice }) => {
  const [ result, setResult ] = React.useState()
  const collectionHandle = result?.data?.collection?.handle

  const number = 5

  React.useEffect(() => {
    let myHeaders = new Headers()
    myHeaders.append("X-Shopify-Storefront-Access-Token", process.env.GATSBY_SHOPIFY_ACCESS_TOKEN)
    myHeaders.append("Content-Type", "application/json")

    var graphql = JSON.stringify({
      query: `
        query ($id: ID) {
          collection(id: $id) {
            handle
            products(first: ${number}) {
              edges {
                node {
                  title
                  handle
                  id
                  images(first: 1) {
                    edges {
                      node {
                        id
                        transformedSrc(maxHeight: 256)
                      }
                    }
                  }
                  priceRange {
                    minVariantPrice {
                      amount
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {"id":`${collection}`}
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: graphql,
      redirect: 'follow'
    }

    fetch(`https://${process.env.GATSBY_SHOP_NAME}.myshopify.com/api/2021-10/graphql.json`, requestOptions)
      .then(response => response.json())
      .then(result => setResult(result))
      .catch(error => console.log('error', error))
  }, [collection])

  return (
    <section className="section">
      <div className="container has-text-centered">
        <Link to={`/collections/${collectionHandle}/`}>
          <h2 className="is-size-3 is-size-4-mobile my-4 has-text-danger is-uppercase" >{ header }</h2>
        </Link>
        <FeatureDivider />
        <div className="columns is-multiline is-mobile">
          {result?.data.collection.products.edges.map(el => {
            const { title, handle, priceRange, id, images } = el.node
            const { altText, transformedSrc } = images.edges[0].node
            return (
              <div className="column is-one-fifth-desktop is-one-third-tablet is-half-mobile" key={id}>

                <Link to={`/collections/${collectionHandle}/products/${handle}/`}>
                  <figure className="image is-square">
                    <img src={transformedSrc} alt={altText}/>
                  </figure>
                  <div className="py-3 has-text-centered is-uppercase has-text-danger">{title}</div>
                  {showPrice === false ? (
                      null
                    ) : (
                      <div className="has-text-centered has-text-danger"><i>from </i>{getPrice(priceRange.minVariantPrice.amount)}</div>
                    )
                  }
                </Link>

              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default FeaturedCollectionFetch